import { addressTransform } from '@/utils/tracking/address'

const INTENT_MAP = {
  SALE: 'BUY',
  RENTAL: 'RENT',
  SELL: 'SELL',
}

const getArray = (value) => [].concat(value).filter(Boolean)
const getNumberArray = (value) => getArray(value).map(Number)
const getNumber = (value) => (Number(value || '') || null)

const onboardingClicked = (filters, { amenities: rawAmenities = [], subject = '' } = {}) => {
  const {
    addresses,
    unitType,
    parkingSpaces,
    bathrooms,
    bedrooms,
    fromPrice,
    toPrice,
    fromArea,
    toArea,
    ...otherFilters
  } = filters
  const unitTypes = unitType ? [unitType.unitType] : []
  const amenities = rawAmenities.split(',')
  const metadata = otherFilters.virtualTour ? ['VIDEO AND VIRTUAL TOUR'] : []

  return {
    onboarding: {
      step: 'DISCOVER',
      action: 'COMPLETE FUNNEL',
      intent: INTENT_MAP[otherFilters.business] || '',
      filter: {
        ...otherFilters,
        amenities,
        addresses: addresses.map((address) => addressTransform(address)),
        unitTypes,
        parkingSpaces: getNumberArray(parkingSpaces),
        bathrooms: getNumberArray(bathrooms),
        bedrooms: getNumberArray(bedrooms),
        fromPrice: getNumber(fromPrice),
        toPrice: getNumber(toPrice),
        fromArea: getNumber(fromArea),
        toArea: getNumber(toArea),
        metadata,
      },
      subject,
    },
    event: 'onboardingClicked',
    _clear: true,
  }
}

export default onboardingClicked
